<template>
  <div class="component-form-newsletter">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <div style="position: relative;">
            <div class="input-back"><i class="fa fa-lg fa-envelope"></i></div>
            <input type="text"
                   name="sku"
                   placeholder="Informe seu e-mail"
                   v-model="search"
                   @keyup.enter.prevent="setSku(false)"
                   @keyup="doSearch"
                   @keyup.arrow-vertical-keys.prevent="navigate"
                   @blur="hide()"
                   @focus="show()"
                   class="form-control input-lg"
                   autocomplete="off"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'FormNewsletter',
    components: {},
    props: [],
    data () {
      return {
        focus: 0,
        visible: false,
        search: '',
        searched: false,
        beforeRequest: false,
        skus: [],
        loading: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {},
    methods: {
      show () {
        this.visible = true
      },
      hide (reset = false) {
        setTimeout(() => {
          this.searched = false
          this.visible = false
          if (reset) this.skus = []
        }, 100)
      },
      setSku (k) {
        if (k) this.focus = k
        this.$router.push({
          name: 'sku',
          params: {
            skuSlug: this.skus[this.focus].slug,
            skuId: this.skus[this.focus].id
          }
        })
      },
      navigate (event) {
        if (event.keyCode === 38) {
          if (this.focus > 0) this.focus -= 1
        }
        if (event.keyCode === 40) {
          if (this.focus < (this.skus.length - 1)) this.focus += 1
        }
      },
      doSearch (event) {
        if (this.search === '' || this.search.length < 3) {
          this.hide()
        } else if (![37, 38, 39, 40, 13, 16, 17, 18, 20, 91, 93, 33, 34, 35, 36].includes(event.keyCode)) {
          this.show()
          this.focus = 0
          this.$http.get('skus?parent=search&search=' + this.search, {
            before (request) {
              this.loading = true
              if (this.beforeRequest) this.beforeRequest.abort()
              this.beforeRequest = request
            }
          }).then((response) => {
            this.skus = response.data
            this.searched = true
            this.loading = false
          }, (error) => {
            if (error.status !== 0) {
              console.log(error)
              this.loading = false
            }
          })
        }
      },
      ...mapActions([])
    }
  }
</script>


// WEBPACK FOOTER //
// FormNewsletter.vue?439cad16